import { ResourcesState, UserFavorite } from 'types';
import { createSelector } from 'reselect';
import { Resource } from 'i18next';
import { filterResources } from 'util/resource-util';
import { ResourcesSections } from 'util/resources-util';

const allResources = (entity: ResourcesState) => {
  return entity.resources;
};
const favoriteResources = entity => entity.favoriteResources;
const getSelectedTags = ({ resource }) =>
  resource.selectedFilters.selectedTags;
const getSearchText = ({ resource }) =>
  resource.selectedFilters.searchText;

export const getFavoriteResources = createSelector(
  [allResources, favoriteResources],
  (allResources: Array<Resource>, favoriteResources: Array<UserFavorite>) => {
    return (
      allResources &&
      allResources
        .filter(resource =>
          favoriteResources.find(userFavorite => userFavorite.resourceId === resource.id)
        )
        .map(resource => {
          const favorites = favoriteResources.filter(
            userFavorite => userFavorite.resourceId === resource.id
          );
          resource.favorites = (favorites !== undefined ? favorites : []) as any;

          return resource;
        })
    );
  }
);

export const getAllResourcesWithFavorites = createSelector(
  [allResources, favoriteResources],
  (allResources: Array<Resource>, favoriteResources: Array<UserFavorite>) => {
    return allResources.map(resource => {
      const favorites = favoriteResources.filter(
        userFavorite => userFavorite.resourceId === resource.id
      );
      if (favorites !== undefined) {
        resource.favorites = favoriteResources.filter(
          userFavorite => userFavorite.resourceId === resource.id
        ) as any;
      } else resource.favorites = [] as any;

      return resource;
    });
  }
);

export const getFilteredResources = createSelector(
  [
    getFavoriteResources,
    getAllResourcesWithFavorites,
    getSelectedTags,
    getSearchText,
    (_, resourcesSection) => resourcesSection
  ],
  (favoriteResources, allResourcesWithFavorites, selectedTags, searchText, resourcesSection) => {
    return filterResources(
      resourcesSection === ResourcesSections.MYSTUFF.code
        ? favoriteResources
        : allResourcesWithFavorites,
      selectedTags,
      searchText
    );
  }
);
